<template>
  <DialogCard>
    <template #title>
      Medical Professionals
    </template>
    <template #text>
      <p>
        Let us harness the power of computational image recognition.
        <span class="text-uppercase">together</span>.
      </p>
      <ul>
        <li>
          We use state-of-the-art Artificial Intelligence to flag abnormalities that are often
          difficult to detect with the human eye alone. Our goal is to offer a new tool to medical
          professionals to inform their diagnosis and treatment.
        </li>
        <li>
          At the same time, neuralike is dedicated to engaging consumers with their medical images,
          so they take on a more proactive stance to their health.
        </li>
        <li>
          The majority of neuralike users choose to share their medical images and reports with
          their healthcare providers. <a>Take a look at a sample report</a> to better understand the
          types of information your patients receive from us and may share with you.
        </li>
        <li>
          As we continue to develop our service, we aim to create image and report formats that fit
          your needs. To achieve this, we depend on your feedback. <a>Get in touch</a> and let us
          know what you like about neuralike and what we can improve.
        </li>
      </ul>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeMedicalProfessionalsDialog',
  components: {
    DialogCard,
  },
};
</script>
